export default __webpack_public_path__ + "static/media/english-to-french-screenshot-05.18166060.png";